<template>
        <b-card no-body class="overflow-hidden">
            <b-row no-gutters>
                <b-col md="6">
                <b-card-img :src="personEntry.person.photo" class="rounded-0"></b-card-img>
                </b-col>
                <b-col md="6">
                <b-card-body :title="`Ingreso ${personEntry.person.name}`">
                    <!-- <b-card-text> -->
                        <b-container>
                            <b-row>
                                <b-col cols="12" md="5">Nombre</b-col>
                                <b-col>{{ personEntry.person.name }}</b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" md="5">Documento</b-col>
                                <b-col>{{ personEntry.person.document }}</b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" md="5">Fecha de ingreso</b-col>
                                <b-col>{{ personEntry.created_at | datetime }}</b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" md="5">Estructura</b-col>
                                <b-col>{{ !!personEntry.person.structure? personEntry.person.structure.name: 'Visitante' }}</b-col>
                            </b-row>
                        </b-container>
                    <!-- </b-card-text> -->
                </b-card-body>
                </b-col>
            </b-row>
        </b-card>
</template>
<script>
export default {
    name: 'person_entry_card',
    props: {
        personEntry: {
            type: Object,
            required: true
        }
    },
    computed: {
        personPhoto() {
            return this.personEntry.person.photo | 'images/avatar_empty.png';
        }
    }
}
</script>